import { Droppable } from '@shopify/draggable'
import { createEl } from '../createElement';
import {clothes} from 'dragGame.data'
import { complete } from '../complete'
import {createSprite} from '../sprites/playSprite'
import {onDropRelease, onDropStop, onDropStart} from 'dragGame.events'
import {playAudio} from '../audio/playAudio'
import {setSceneStatus} from '../utils'
import {transition} from '../transition'
import {showHelpButton} from '../controls'

function dragGame() {
  transition('fadeFromWhite', {
    onEnd: playGame
  })
}

function playGame() {

  // set scene status
  setSceneStatus('dragGame')

  // play intro audio
  playAudio('round1/ambience')
  playAudio(['round1/vo_intro'], {
    onEnd: () => {
      playAudio('round1/vo_shorts')
    },
    onEndOrInterrupt: () => {
      showHelpButton()
      playAudio('round1/music')
    }
  })

  // create containers
  const gameRoot = createEl('div', {id: 'drag-game'}, document.getElementById('root') )
  createSprite('Santa', gameRoot)

  // create dropzones for each item of clothing: one on Santa, one in the environment
  function createDropzone(name, disabled) {
    const dropzoneId = `dropzone ${name}`
    // create first dropzone (where item needs to go)
    createEl('div', { class: dropzoneId, "data-object": name, "data-container": "santa" }, gameRoot )
    // create second dropzone (where item starts)
    const dropzone2 = createEl('div', { class: dropzoneId, "data-object": name, "data-container": "environment" }, gameRoot )
    // create object
    let sprite = createSprite( name, dropzone2 )
    sprite.setAttribute('class', `object ${name}`)
    sprite.setAttribute('data-object', name)
    sprite.setAttribute('data-disabled', disabled)
  }

  // create dropzones for each piece of clothing
  let i = 0, disabled
  for (const [key] of Object.entries(clothes) ) {
    i++
    // enforce order each item of clothing has to be added in
    // (controlled by what appears first in the clothes object)
    if(i === 1) {
      disabled = false
    }
    else {
      disabled = true
    }
    createDropzone(key, disabled)
  }

  let droppable = new Droppable(document.querySelectorAll('#drag-game'), {
    draggable: `.object`,
    dropzone: `.dropzone`
  })

  droppable.on('droppable:dropped', (e) => {
    onDropRelease(e, droppable)
  })

  droppable.on('droppable:stop', (e) => {
    onDropStop(e, droppable, () => { // on complete
      playAudio('round1/vo_outro', {
        onEnd: () => {
          endGame()
        }
      })
    })
  })

  droppable.on('droppable:start', (e) => {
    onDropStart(e, droppable)
  })

  function endGame() {
    // run complete
    complete('dragGame', () => {
      // clean up game resources
      gameRoot.parentNode.removeChild(gameRoot)
      droppable.destroy()
    })
  }

}

export {dragGame}
